/* « Votre lieu n'est pas là ? » — envoi de la demande vers Affichely Studio.
 *
 * Un lieu absent est la seule information que le catalogue ne peut pas produire tout seul :
 * elle vient du client, et c'est elle qui dit quelle collection ouvrir ensuite.
 *
 * On n'envoie que le lieu, l'adresse et la langue — de quoi répondre, rien de plus. Le
 * formulaire ne recharge pas la page : quelqu'un qui vient de parcourir douze destinations
 * ne doit pas les perdre pour avoir demandé la treizième.
 */
(function () {
  "use strict";

  var form = document.querySelector("[data-ihub-form]");
  if (!form) return;

  var etat = form.querySelector("[data-ihub-etat]");
  var bouton = form.querySelector("button[type=submit]");
  var I18N = {};
  try { I18N = JSON.parse(form.getAttribute("data-i18n") || "{}"); } catch (e) { I18N = {}; }
  var t = function (k, fb) { return I18N[k] || fb; };

  function dire(msg, erreur) {
    if (!etat) return;
    etat.hidden = false;
    etat.textContent = msg;
    etat.classList.toggle("is-err", !!erreur);
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var lieu = (form.elements.lieu.value || "").trim();
    var email = (form.elements.email.value || "").trim();
    if (!lieu || !email) return;

    bouton.disabled = true;
    dire(t("envoi", "Envoi…"), false);

    fetch(form.getAttribute("data-endpoint"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      mode: "cors",
      credentials: "omit",
      body: JSON.stringify({
        lieu: lieu,
        email: email,
        locale: form.getAttribute("data-locale") || "",
        site: (form.elements.site && form.elements.site.value) || ""
      })
    }).then(function (r) {
      if (r.ok) {
        /* On remplace le formulaire par le remerciement plutôt que de le laisser
           rempli : sinon on invite à renvoyer la même demande. */
        form.querySelector(".ihub__champs").hidden = true;
        var p = form.querySelector(".ihub__prive");
        if (p) p.hidden = true;
        dire(t("merci", "C’est noté. On vous écrit dès que cette collection ouvre."), false);
        return;
      }
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (d.error === "email_invalide") dire(t("email_ko", "Cette adresse ne semble pas valide."), true);
        else if (d.error === "rate_limited") dire(t("trop", "Trop de demandes d’un coup. Réessayez dans un moment."), true);
        else dire(t("echec", "Envoi impossible pour l’instant. Réessayez plus tard."), true);
        bouton.disabled = false;
      });
    }).catch(function () {
      dire(t("echec", "Envoi impossible pour l’instant. Réessayez plus tard."), true);
      bouton.disabled = false;
    });
  });
})();
